/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Form, TextArea } from 'semantic-ui-react';
var defaultProps = {
  specialInstructions: null,
  onSpecialInstructionsChange: null,
  loading: false,
  maxlength: 280
};
export default function SpecialInstructionsForm(_ref) {
  var specialInstructions = _ref.specialInstructions,
    onSpecialInstructionsChange = _ref.onSpecialInstructionsChange,
    loading = _ref.loading,
    maxlength = _ref.maxlength;
  return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(TextArea, {
    maxlength: maxlength,
    disabled: loading,
    value: specialInstructions,
    onChange: onSpecialInstructionsChange
  }));
}
SpecialInstructionsForm.defaultProps = defaultProps;